<template>
    <el-dialog
            title="Update dispatcher"
            :visible.sync="showForm"
            append-to-body
            top="5vh"
            @closed="reset()"
    >
        <dispatcher-dialog-form 
            :form-data="formData"
            @updated="$emit('updated')"
        ></dispatcher-dialog-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="remove" class="float-left">Delete</el-button>
            <el-button @click="showForm = false">Close</el-button>
            <el-button @click="save" type="primary">Save</el-button>
        </span>
    </el-dialog>
</template>

<script>
import DispatcherDialogForm from "./dispatcher-dialog-form";

export default {
        components: {
            DispatcherDialogForm
        },
        props: [
            'show',
            'dispatcher',
        ],
        data() {
            return {
                formData: {},
            };
        },
        watch: {
            dispatcher: {
                deep: true,
                handler() {
                    this.reset();
                }
            }
        },
        computed: {
            showForm: {
                get() { return this.show; },
                set(val) { this.$emit('close'); }
            },
        },
        methods: {
            save() {
                return axios.post(url(`admin/settings/dispatchers/${this.dispatcher.id}/update`), this.formData)
                    .then((response) => {
                        this.$message({
                            message: `Dispatcher updated`,
                            type: 'success'
                        });

                        this.showForm = false;
                        this.$emit('updated');
                    });
            },
            remove() {
                this.$confirm('Are you sure you want to delete this company?', 'Warning', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.showForm = false;

                    return axios.post(url(`admin/settings/dispatchers/${this.dispatcher.id}/delete`))
                        .then((response) => {
                            this.$message({
                                message: `Dispatcher has been deleted`,
                                type: 'success'
                            });
                            this.$emit('updated');
                        });
                });
            },
            reset() {
                this.formData = _.cloneDeep(this.dispatcher);
            },
        },
        created() {
            this.reset();
        }
    }
</script>
